import React, { useEffect, useState } from "react";

const Preloader = () => {
  const [loading, setLoading] = useState(true);
  const [hide, setHide] = useState(false);

  useEffect(() => {
    // Sau 1.5s: chuyển sang trạng thái loaded (chạy animation slide)
    const timer1 = setTimeout(() => {
      setLoading(false);
    }, 1500);

    // Sau thêm 1s nữa: ẩn hẳn Preloader khỏi DOM
    const timer2 = setTimeout(() => {
      setHide(true);
    }, 2500);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  if (hide) return null; // gỡ khỏi DOM sau khi xong hẳn

  return (
    <div
      id="preloader"
      className={`preloader ${!loading ? "loaded" : ""}`}
    >
      <div className="animation-preloader">
        <div className="spinner"></div>
        <div className="txt-loading">
          {["D", "E", "S", "I", "G", "N", "2", "4"].map((letter, index) => (
            <span
              key={index}
              data-text-preloader={letter}
              className="letters-loading"
            >
              {letter}
            </span>
          ))}
        </div>
        <p className="text-center">Loading</p>
      </div>

      <div className="loader">
        <div className="row">
          <div className="col-3 loader-section section-left">
            <div className="bg"></div>
          </div>
          <div className="col-3 loader-section section-left">
            <div className="bg"></div>
          </div>
          <div className="col-3 loader-section section-right">
            <div className="bg"></div>
          </div>
          <div className="col-3 loader-section section-right">
            <div className="bg"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
